export function removePhonePrefix(phone: string): string {
  const prefixLength = 3; // Длина префикса '375'
  return phone.startsWith('375') ? phone.slice(prefixLength) : phone;
}

export function checkPhonePrefix(phone: string): string {
  return phone.startsWith('375') ? '+' + phone : '+375' + phone;
}
